import cms from './cms';

export interface SettingsResponse {
  name: string;
  custom_setting: string[];
}

/**
 * Function to get settings by key
 * @param key of type string
 * @returns Promise<SettingsResponse>
 */
export async function getSettingsByKey(key: string): Promise<SettingsResponse> {
  try {
    const response = await cms.get(`/settings/${key}`);
    return response.data;
  } catch (error) {
    console.error('Error getting settings by key:', error);
    throw error;
  }
}

/**
 * Function to get addons configuration
 * @returns Promise<string[]> - Array of price IDs to remove
 */
export async function getAddonsConfig(): Promise<string[]> {
  try {
    const settings = await getSettingsByKey('addons');
    return settings.custom_setting || [];
  } catch (error) {
    console.error('Error getting addons config:', error);
    return [];
  }
}
